import { Injectable } from "@angular/core";
import { IOrganization } from "@main/companies";
import { IGoverningBody } from "@project/governingbody/governingbody";
import { UserService } from "./user.service";
import { PermissionService } from "@main/permissions/permission.service";
import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { HttpClient } from "@angular/common/http";

declare type UserFilters = {
    organizations: IOrganization[];
    permissionDependencies: { [permission: string]: string[][] };
    governingBodies: IGoverningBody[];
};

@Injectable({
    providedIn: "root"
})
export class UserFiltersService extends BaseDataService {
    readonly url = "api/user/filters";

    constructor(
        http: HttpClient,
        handlersFactory: HttpResponsesHandlersFactory,
        private userService: UserService,
        private permissionService: PermissionService
    ) {
        super(http, handlersFactory);
    }

    async loadUserFilters(): Promise<UserFilters> {
        const [organizations, permissionDependencies, governingBodies] = await Promise.all([
            this.loadOrganizations(),
            this.userService.getPermissionsDependencies(),
            this.loadGoverningBodies()
        ]);

        return {
            organizations,
            permissionDependencies,
            governingBodies
        };
    }

    public loadOrganizations() {
        return this.handleRequest(
            this.http.get<IOrganization[]>(`${this.url}/organizations`),
            this.handlersFactory.getDefault({ showSuccessMessage: false })
        );
    }

    public loadGoverningBodies() {
        return this.handleRequest(
            this.http.get<IGoverningBody[]>(`${this.url}/governing-bodies`),
            this.handlersFactory.getDefault({ showSuccessMessage: false })
        );
    }
}
